/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Warning_Query_Too_LongInputs */

const en_warning_query_too_long = /** @type {(inputs: Warning_Query_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The query is longer than ${i?.max} characters, the rest is ignored`)
};

const de_warning_query_too_long = /** @type {(inputs: Warning_Query_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Abfrage ist länger als ${i?.max} Zeichen, der Rest wird ignoriert`)
};

/**
* | output |
* | --- |
* | "The query is longer than {max} characters, the rest is ignored" |
*
* @param {Warning_Query_Too_LongInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warning_query_too_long = /** @type {((inputs: Warning_Query_Too_LongInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warning_Query_Too_LongInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_warning_query_too_long(inputs)
	return en_warning_query_too_long(inputs)
});